// extracted by mini-css-extract-plugin
module.exports = {"profileResources":"profile-resources_profileResources__2a-TT","carousel":"profile-resources_carousel__3zfHw","item":"profile-resources_item__3GYNL"};